import React from 'react'

import {media} from 'styled-bootstrap-grid'
import styled from 'styled-components'

import {Title4, PLarge, P} from 'src/components/typography'
import {CheckoutReceiptLine} from 'src/components/checkout'
import {formatDate} from 'src/utils/dates'
import {formatNumber} from 'src/utils/numbers'
import type {Order} from 'src/api/saleor/generated'
import {fromGlobalId} from 'src/utils/graphql'
import {isNotNull} from 'src/utils/isNotNull'

export interface CheckoutReceiptProps {
  order: Order
}

const Receipt = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  width: 100%;
  padding: 0 8px;

  ${media.md`
    padding: 0 32px;
  `}
`
const SummaryLines = styled.div`
  padding: 16px 0;
`

const ReceiptLine = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 5px 0;
  position: relative;
`

export default function CheckoutReceipt({
  order,
}: CheckoutReceiptProps): JSX.Element {
  const {lines, created, total, subtotal, discounts, id, shippingPrice} = order

  const date = formatDate(created)
  const subTotal = subtotal?.gross?.amount
  const vsk = subtotal?.tax?.amount
  const shippingPriceAmount = shippingPrice?.gross?.amount
  const totalPrice = total?.gross?.amount

  // TODO: Test with discount, when discount is solved in BC
  const discount = discounts?.[0]?.amount?.amount

  return (
    <Receipt>
      <Title4>{`Pöntun #${fromGlobalId(id)?.id}`}</Title4>
      <PLarge withGutter color="black40">
        {date}
      </PLarge>
      {lines?.filter(isNotNull).map((line) => (
        <CheckoutReceiptLine key={line.id} line={line} />
      ))}
      <SummaryLines>
        <ReceiptLine>
          <P>Verð með VSK </P>
          <P>{formatNumber(subTotal)} kr.</P>
        </ReceiptLine>
        <ReceiptLine>
          <P>Þar af VSK </P>
          <P>{formatNumber(vsk)} kr.</P>
        </ReceiptLine>
        {discount && discount > 0 ? (
          <ReceiptLine>
            <P>Afsláttur</P>
            <P color="red">{formatNumber(-1 * discount)} kr.</P>
          </ReceiptLine>
        ) : null}
        <ReceiptLine>
          <P>Sendingarkostnaður</P>
          <P>{formatNumber(shippingPriceAmount)} kr.</P>
        </ReceiptLine>
        <ReceiptLine>
          <PLarge bold>Samtals</PLarge>
          <PLarge bold>{formatNumber(totalPrice)} kr.</PLarge>
        </ReceiptLine>
      </SummaryLines>
    </Receipt>
  )
}
